class MobileAccordion extends HTMLElement {
  connectedCallback() {
    const toggleButton = this.querySelector('mobile-accordion-toggle');
    toggleButton.addEventListener('click', () => {
      this.toggleAccordion(toggleButton);
    });
  }

  toggleAccordion(clickedButton) {
    const accordions = document.querySelectorAll('mobile-accordion');
    accordions.forEach(accordion => {
      if (accordion !== clickedButton.parentElement) {
        accordion.classList.remove('active');
      }
    });
    clickedButton.parentElement.classList.toggle('active');
  }
}

customElements.define('mobile-accordion', MobileAccordion);
